/* globals dataLayer, adobe */
(function(window, angular, undefined) {
    angular.module('formApp')
        .controller('stepTwoCtrl', ['$scope', '$rootScope', '$q', 'FormService', 'formData', '$state', '$log', 'scrollToPoint', 'errorHandler', 'LoadingInterceptor', '$timeout', 'sessionService','dataLayerService', 'updateHeader',
        function($scope, $rootScope, $q, formService, formData, $state, $log, scrollToPoint, errorHandler, loadingInterceptor, $timeout, sessionService, dataLayerService, updateHeader) {
           
            var evt = new CustomEvent("currentStep", {detail: {step:"2"}});
            window.dispatchEvent(evt);

            console.log('event dispatched',evt);
            
            $scope.captcha = {
                enabled: sessionStorage.getItem("tandtCaptchaTest") === "true"
            };

            sessionService.start();

            if (sessionStorage.getItem('eQuote') || sessionStorage.getItem('eCoverNote')){
                sessionStorage.removeItem('formStateUri');
                sessionStorage.removeItem('retrieveQuote');
                sessionStorage.removeItem('eQuote');
                sessionStorage.removeItem('eCoverNote');
                sessionStorage.removeItem('campaign');
                sessionStorage.removeItem('brav');
                sessionStorage.removeItem('eCoverJourney');
            }
                
            sessionStorage.setItem('currentRefreshState','step-2');

            //AH-6124
            var timeout = timeout ? clearTimeout(timeout) : null;
            var env = ['localhost', 'quote-dev.petplan.co.uk', 'quote-int.petplan.co.uk'].includes(window.location.hostname);
            angular.element(document).ready(function () {
                $scope.techError = $scope.formData.runningTotals ? false : true;
                if (!env) {
                    if (!$scope.formData.runningTotals) {
                        timeout = setTimeout(function () {
                        $scope.techError = false;
                        }, 14000);
                    }
                }
                else {
                    console.log('environment', env);
                    $scope.techError = false;
                }
            });

            $scope.matchCover = true;

            function returnPetAge(dob){
                var a = moment();
                var b = moment(dob);

                
                var years = a.diff(b, 'year');
                b.add(years, 'years');
                
                var months = a.diff(b, 'months');
                b.add(months, 'months');
                
                var days = a.diff(b, 'days');

                var petAge =
                {
                    "years": years,
                    "months": months,
                    "days": days
                };
                
                 return petAge;
                
            }

             $scope.$watch('gatewayReady', function () {
                 if ($scope.gatewayReady === true && sessionStorage.getItem('formStateUri')) {
                     formService.setApplicationId(sessionStorage.getItem('formStateUri'));
                     refresh().then(function (response) {
                         $scope.formData.pets = response.data.application.pets || $scope.formData.pets;
                         $scope.formData.cover = response.data.application.cover || $scope.formData.cover;
                         $scope.formData.aboutYou = response.data.application.aboutYou || $scope.formData.aboutYou;

                          var preQuoteVariables = [];
                          var i;

                         function returnPetBreed (type,breedOne,breedTwo){
                             if (type === 'MultiBreed'){
                                return breedOne+','+ breedTwo;
                             }
                             else{
                                    return breedOne;
                             }
                         }

                         for (i = 0; i < $scope.formData.pets.length; i++) { 


                             var currentPet = {
                               "petDetailsPosition": i, 
                                "species": $scope.formData.pets[i].type,
                                "petType": $scope.formData.pets[i].details.type,
                                "breed":   returnPetBreed ($scope.formData.pets[i].details.type, $scope.formData.pets[i].details.breedOne,$scope.formData.pets[i].details.breedTwo),
                                "weight": "n/a",
                                "gender": $scope.formData.pets[i].details.sex,
                                "neutered": $scope.formData.pets[i].details.spayedOrNeutered,
                                "petAge" :returnPetAge($scope.formData.pets[i].details.dateOfBirth)
                             };
                             preQuoteVariables.push(currentPet);
                         }

                         //------------------------GA STUFF----------------------------/

                         dataLayer.push({
                             'event': 'dataAvailable',
                             'funnelName': parseInt($rootScope.campaignFunnel),
                             'funnelVersion': '1.0',
                             'funnelPageNumber': 2,
                             'environment': window.location.hostname,
                             'bravCode': '',
                             'campaignCode': dataLayerService.campaignCode(),
                             'partnerName': dataLayerService.partnerName(),
                             'numberOfPets': $scope.formData.pets.length,
                             'multipetFlag': dataLayerService.multiPetTest($scope.formData.pets.length),
                           //  'breed':dataLayerService.getBreed($scope.formData.pets),
                             "quoteVariables": preQuoteVariables
                         });
                        

                        //------------------------GA STUFF----------------------------//

                        // SESSIONCAM 
                        if(window.sessionCamRecorder) {
                            if(window.sessionCamRecorder.createVirtualPageLoad) {
                                window.sessionCamRecorder.createVirtualPageLoad('stepTwo');
                            }
                        }
                        
                     });
                 }
                 function refresh() {
                     return formService.getApplication();
                 }
             });
             

            $scope.dobDateMin = moment().subtract(18, 'year').format('YYYY-MM-DD');
            $scope.dobDateMax = moment().subtract(120, 'year').format('YYYY-MM-DD');
            
            $scope.formData = formData;
            $scope.address = {
                show: false
            };

            var petBreed = sessionStorage.getItem('petBreed');
            var getPetType = sessionStorage.getItem('petType');
            
            var petType = $scope.formData.pets[0].type;

            if (petBreed && $scope.formData.pets.length === 1) {
                if (petType === 'dog' && petBreed) {
                    updateHeader.petType = petBreed;
                } else {
                    updateHeader.petType = getPetType || petType;
                }
            } 
            else if ($scope.formData.pets.length > 1) {
                sessionStorage.removeItem('petBreed');
                updateHeader.petType = 'multipet'; }
            else {
                
                updateHeader.petType = getPetType || petType;

            }


            $scope.hideDiscount = sessionStorage.getItem('hideDiscount');

            $scope.submit = function () {
              if (!$scope.techError) {
                if (hasValidAddressFieldLengths()) {
                  submitDetails();
                } else {
                  $scope.address.show = true;
                }
              } else {
                //console.log('AH-6124');
                clearTimeout(timeout);
                $state.go("tech-error", { forward: true });
              }
            };

            function hasValidAddressFieldLengths() {
                var isValid = true;
                angular.forEach(['houseNameOrNumber', 'street', 'addressLine2', 'town', 'county'], function(key,value) {
                    if ($scope.schema.application.aboutYou[key].required && !$scope.formData.aboutYou[key]) {
                        isValid = false;
                    }
                    if ($scope.schema.application.aboutYou[key].hasOwnProperty('constraints') ) {
                        var maxlength = $scope.schema.application.aboutYou[key].constraints.filter(function(constraint) {
                            return constraint.type === 'length';
                        });
                        if (maxlength.length > 0 && $scope.formData.aboutYou[key] && $scope.formData.aboutYou[key].length > maxlength[0].max) {
                            isValid = false;
                        }
                    }
                });
                return isValid;
            }

            function captchaResponse() {
                if ($scope.captcha.reCaptcha) {
                    var recaptchaPost = {
                        "action" : "verify",
                        "clientResponse" : $scope.captcha.reCaptcha
                    };
                    return formService.postCaptchaToken(recaptchaPost);
                } else {
                    var deferred = $q.defer();
                    deferred.resolve();
                    return deferred.promise;
                }             
            }            

            function submitDetails() {
                loadingInterceptor.incrementRequests();
                captchaResponse().then(function() {
                    return formService.postAboutYou($scope.formData.aboutYou);
                }).then(function() {
                    loadingInterceptor.decrementRequests();

                    var step3State = 'quote';
                    var i=0;
                    
                    step3State = 'quote';
                    while (i < $scope.formData.pets.length -1 && $scope.formData.pets[i].chosenCover && $scope.formData.pets[i].chosenCover.productId && $scope.formData.pets[i].chosenCover.productLine) {
                        i++;
                    }
                    console.log('i = ', i);
                    if(!$scope.formData.pets[i].chosenCover) {
                        step3State = 'quote';
                    } else {
                        step3State = 'quote';
                    } 
                    $state.go('step-3-select', {id: i, selectState: step3State, forward: true  });

                }).catch(function(error) {
                   errorHandler.reportErrors(error,'redirect','tech');
                });               
            }

            $scope.gotoProduct = function (product,speed,type) {

                $timeout(function () {
                    scrollToPoint.scrollTo(product,speed,type);
                }, 0, false);

            };

            function reportErrors(fault) {
                if (fault.message) {
                    $log.error( fault.message );
                } else {
                    $log.error( JSON.stringify(fault) );
                }
            }

            
            

        }]);
})(window, window.angular);